// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"loaderOverlay_loaderContainer__27Ahe","loader":"loaderOverlay_loader__KPKnp","spinner":"loaderOverlay_spinner__1M2dQ"};